// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ADJM","colMin":"styles_colMin__2bvRC"};